export default __webpack_public_path__ + "static/media/TRR-drink-cereal-milk-latte.86bc8046.png";